import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { useMemo } from 'react';
import { cn, useBudgetSummary, useCurrencyFormatter } from '@liquidbudget/common';

type Props = {};

export function AccountSummaryCard({}: Props) {
  const budgetSummary = useBudgetSummary();
  const formatCurrency = useCurrencyFormatter();

  // Calculate total net worth and determine if we have off-budget accounts
  const { totalNetWorth } = useMemo(() => {
    const { accountSummary } = budgetSummary;
    const total = accountSummary.offBudgetNetWorth + accountSummary.liquidNetWorth;

    return {
      totalNetWorth: total,
    };
  }, [budgetSummary]);

  return (
    <Accordion type="multiple" className="w-full mb-2">
      <AccordionItem value="net-worth" className="border rounded-lg shadow-sm overflow-hidden">
        <AccordionTrigger
          className={cn('hover:no-underline w-full px-3 py-2  text-sm relative', 'bg-white dark:bg-slate-950')}
        >
          <div className="ml-1 flex justify-between items-center w-full">
            <span className={cn('font-semibold dark:text-slate-200')}>Net Worth</span>
            <span className={cn('dark:text-slate-200')}>{formatCurrency(totalNetWorth)}</span>
          </div>
        </AccordionTrigger>
        <AccordionContent className="bg-card">
          <div className="p-3 pt-0 space-y-2">
            {/* Liquid Accounts Section */}
            <h4 className="text-xs  text-muted-foreground flex items-center justify-between">
              <span className="ml-5 font-semibold">Liquid Accounts</span>
              <span className="font-mono">{formatCurrency(budgetSummary.accountSummary.nonCreditCardBalance)}</span>
            </h4>

            {/* Credit Cards Section */}
            <h4 className="text-xs  text-muted-foreground flex items-center justify-between">
              <span className="ml-5 font-semibold">Credit Cards</span>
              <span className="font-mono">{formatCurrency(budgetSummary.accountSummary.creditCardBalance)}</span>
            </h4>

            {/* Off-Budget Accounts Section - only show if they exist */}
            <h4 className="text-xs  text-muted-foreground flex items-center justify-between">
              <span className="ml-5 font-semibold">Off-Budget Assets</span>
              <span className="font-mono">{formatCurrency(budgetSummary.accountSummary.offBudgetAssetBalance)}</span>
            </h4>

            <h4 className="text-xs  text-muted-foreground flex items-center justify-between">
              <span className="ml-5 font-semibold">Off-Budget Liabilities</span>
              <span className="font-mono">
                {formatCurrency(budgetSummary.accountSummary.offBudgetLiabilityBalance)}
              </span>
            </h4>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
